module.exports = __webpack_public_path__ + "static/media/infoJumbo1.fb9b7943.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/Almi/images/infoJumbo1.jpg
// module id = 497
// module chunks = 0